<template>
  <div id="pers-tab1" name="hres31x-tab1" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">

    <!--Start Topic #1-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic1">
      <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ constLabels[nowLang].Topic.generalData }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic1">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['100'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codsex'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['40'] }}</div>
        <div class="col-xs-6 data-text">
          {{ detail['dteempdb_y'] }} {{ labels['HRES31XC1']['160'] }}
          {{ detail['dteempdb_m'] }} {{ labels['HRES31XC1']['170'] }}
        </div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['70'] }}</div>
        <div class="col-xs-6 data-text">
          {{ detail['tchildrn'] }} {{ labels['HRES31XC1']['80'] }}
        </div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['90'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['stamarry'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['110'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codedlv'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['120'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codinst'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['130'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['desnoffi'] }}</div>
      </div>
    </div>
    <!--End Topic #1-->
    <!--Start Topic #2-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic2">
      <i class="fa fa-laptop icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ constLabels[nowLang].Topic.aboutWork }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic2">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['140'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numtelof'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['210'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['staemp'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['230'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codempmt'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['250'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['typpayroll'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['150'] }}</div>
        <div class="col-xs-6 data-text">
          {{ detail['dteempmt_y'] }} {{ labels['HRES31XC1']['160'] }}
          {{ detail['dteempmt_m'] }} {{ labels['HRES31XC1']['170'] }}
        </div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['200'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteempmt']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['220'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteoccup']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC1']['240'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteefpos']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ detail['unitcal1'] === 'D' ? labels['HRES31XC4']['70'] : labels['HRES31XC1']['260'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['amtincom'] }} {{ labels['HRES31XC1']['270'] }}</div>
      </div>
    </div>
    <!--End Topic #2-->
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres31x-tab1',
  data () {
    return {
      constLabels: {
        en: {
          Topic: {
            generalData: 'General Data',
            aboutWork: 'About Work'
          }
        },
        th: {
          Topic: {
            generalData: 'ข้อมูลทั่วไป',
            aboutWork: 'เกี่ยวกับงาน'
          }
        }
      },
      subTopic1: true,
      subTopic2: true
    }
  },
  methods: {
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>



// WEBPACK FOOTER //
// tab1.vue?d07c020a